import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allGoalsList: null
}

const GoalSlice = createSlice({
  name: 'goal',
  initialState,
  reducers: {
    setAllGoalsList(state, action){
      state.allGoalsList = action.payload
    }
  }
})


// reducers exports
export const {
  setAllGoalsList
} = GoalSlice.actions;

export default GoalSlice.reducer;